import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  TOUR_CANCEL_REASON_TOUR_RELATED_OPTION_ITEMS,
  TOUR_CANCEL_REASON_CUSTOMER_RELATED_OPTION_ITEMS,
  TOUR_STATUS_CANCELLED,
} from 'common/tourConstants';

import { SR_API_ACTION_APPLY_TOUR_STATE_CHANGE } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import SrOptionSelectionModal from 'client/components/SrOptionSelectionModal';

const TOUR_CANCEL_REASON_CATEGORY_TOUR_RELATED = 'tourRelated';
const TOUR_CANCEL_REASON_CATEGORY_CUSTOMER_RELATED = 'customerRelated';

const TOUR_CANCEL_REASON_CATEGORY_TO_OPTION_ITEMS_MAPPING = {
  [TOUR_CANCEL_REASON_CATEGORY_TOUR_RELATED]: TOUR_CANCEL_REASON_TOUR_RELATED_OPTION_ITEMS,
  [TOUR_CANCEL_REASON_CATEGORY_CUSTOMER_RELATED]: TOUR_CANCEL_REASON_CUSTOMER_RELATED_OPTION_ITEMS,
};

class SrAdminTourCardDeleteDropdown extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: null,
      tourCancelNote: null,
    };
  }

  _handleTourCancellationCategoryClick = (e) => {
    const tourCancelNote = global.prompt('Tour Cancel Note:') || '';

    this.setState({
      tourCancelNote: tourCancelNote,
      selectedCategory: e.target.dataset.cancellationCategory,
    });
  };

  _onTourCancellationReasonSubmit = (tourCancelReason) => {
    const { tourCancelNote } = this.state;

    if (!global.confirm(`Are you sure you want to cancel this tour with "${tourCancelReason}"?`)) {
      return;
    }
    const { tour, reloadDataTableTour, dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_APPLY_TOUR_STATE_CHANGE,
      payload: {
        entityId: tour.id,
        toState: TOUR_STATUS_CANCELLED,
        entityTransitionUpdates: {
          cancelReason: tourCancelReason,
          cancelNote: tourCancelNote,
        },
      },
    }).then(reloadDataTableTour);
  };

  _onTourCancellationCancel = () => {
    this.setState({
      selectedCategory: null,
    });
  };

  render() {
    const { selectedCategory } = this.state;
    const tourCancelReasonOptionItems =
      TOUR_CANCEL_REASON_CATEGORY_TO_OPTION_ITEMS_MAPPING[selectedCategory];

    return (
      <div className="dropdownContainer">
        <span
          className="option"
          data-cancellation-category={TOUR_CANCEL_REASON_CATEGORY_TOUR_RELATED}
          onClick={this._handleTourCancellationCategoryClick}
        >
          cancel tour
        </span>
        <span
          className="option"
          data-cancellation-category={TOUR_CANCEL_REASON_CATEGORY_CUSTOMER_RELATED}
          onClick={this._handleTourCancellationCategoryClick}
        >
          mark user as dead
        </span>
        {tourCancelReasonOptionItems && (
          <SrOptionSelectionModal
            headline="Choose Fail Reason"
            optionItems={tourCancelReasonOptionItems}
            onSubmit={this._onTourCancellationReasonSubmit}
            onCancel={this._onTourCancellationCancel}
          />
        )}
      </div>
    );
  }
}

SrAdminTourCardDeleteDropdown.displayName = 'SrAdminTourCardDeleteDropdown';

export default SrAdminTourCardDeleteDropdown;
